export enum CloudTypesEnum {
    FILE = 'file',
    FOLDER = 'folder',
}

export enum ContextMenuActionsEnum {
    RENAME = 'rename',
    DELETE = 'delete',
}
